import React, { useState, useEffect } from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import get from "lodash/get";
import { string } from "prop-types";

import "./gdprPolicy.m.css";

const GdprPolicy = ({ domainLink, pageType }) => {
  const [showGdpr, setShowGdpr] = useState(false);
  useEffect(() => {
    if (pageType !== "home-preview" && pageType !== "story-preview" && pageType !== "story-public-preview-page") {
      setShowGdpr(true);
    }
  }, [pageType]);

  if (getCookieConsentValue()) {
    const cookies = new Cookies();
    cookies.set("CookieConsent", true, { path: "/", maxAge: 60 * 60 * 24 * 365 });
  }
  return showGdpr ? (
    <div>
      <CookieConsent
        location="bottom"
        buttonText="OK"
        containerClasses="gdpr-wrapper"
        style={{
          background: "#001246",
          fontSize: "14px",
          padding: "8px",
          fontFamily: "Roboto, Arial, Helvetica, sans-serif",
          display: "grid",
          gridAutoFlow: "column",
          justifyContent: "center",
        }}
        buttonWrapperClasses="ok-button-link"
        buttonStyle={{ 
          background: "#0099ff",
          color: "#fff",
          fontSize: "14px",
          borderRadius: "3px",
          padding: "3px 8px",
          margin: "0 0 0 12px",
        }}
        contentStyle={{ margin: "auto" }}
      >
        By using this site, you agree to our{" "}
        <a
          href={`${domainLink}/privacy-policy`}
          rel="noreferrer"
          target="_blank"
          style={{ textDecoration: "underline", color: "#fff" }}
        >
          Privacy Policy
        </a>
        .
      </CookieConsent>
    </div>
  ) : null
  
};

GdprPolicy.propTypes = {
  domainLink: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  domainLink: get(state, ["qt", "currentHostUrl"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
});

export default connect(mapStateToProps, "")(GdprPolicy);
